import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import Router from '../components/Routes';
import LoginPage from '../components/Login/LoginPage.tsx';
import ProtectedRoute from '../components/Routes/ProtectedRoute.jsx';
import { authAtom } from '../Services/_states/auth.js';
import { useRecoilValue } from 'recoil';
import { ConstantActions } from '../Services/_actions/constant.actions.js';
import ResetPassword from '../components/Login/ResetPassword.tsx';
import SessionExpiredModal1 from '../components/Modals/SessionExpiredModal/SessionExpiredModal.jsx';
import TestRoutes from '../components/examPortal/index.tsx';
// import ParentTeacherDashboard from '../components/Test/ParentTeacherDashboard.tsx';

function AppRouter() {
  const auth = useRecoilValue(authAtom);
  const { getDynamicHomePageLink } = ConstantActions();
  const HandleRoutes = () => {
    try {
      if (!auth?.token) {
        return <Navigate to={`/r/login`} replace={true} />;
      } else if (auth?.token) {
        let dynamicHomePageLink = getDynamicHomePageLink();
        return <Navigate to={dynamicHomePageLink} replace={true} />;
      } else return <Navigate to={`/r/404`} replace={true} />;
    } catch (error) {
      return <Navigate to={`/r/404`} replace={true} />;
    }
  };
  // const isTestRoute = location.pathname.startsWith('/r/test/');

  return (
    <Routes>
      <Route path="/r/login" element={<LoginPage />} />
      <Route path="/r/login?username=arun_prasath123&password=Machadalo@123" element={<LoginPage />} />

      <Route path="/r/session-expired" element={<SessionExpiredModal1 />} />

      <Route path="/r/reset-password/:code/:email" element={<ResetPassword />} />
      {/* <Route path="/r/test/*" element={<TestRoutes />} /> */}
      <Route
        path="r/*"
        element={<ProtectedRoute element={<Router />} permissionGranted={true} />}
      />
      <Route path="*" element={<HandleRoutes />} />
      {/* <Route path="/r/dashboard/:type" element={<ParentTeacherDashboard />} /> */}
    </Routes>
  );
}
export default AppRouter;
